/**
 * Safe JSON-LD serialization for structured data (<script type="application/ld+json">).
 *
 * SECURITY (security-guidance): dynamic values (listing titles, city names…)
 * flow into a script tag via dangerouslySetInnerHTML. JSON.stringify alone is
 * NOT enough — a value containing `</script>` would close the tag and inject
 * markup. Escaping `<` as < (valid JSON, identical parse result) makes
 * breakout impossible. ALL dynamic JSON-LD must go through this helper; only
 * fully-static literals may be inlined (see index.html).
 */
export function serializeJsonLd(data: object): string {
  return JSON.stringify(data).replace(/</g, '\\u003c');
}
